import { Navigate } from "react-router-dom";

/** Legacy route — company settings now live under Settings > Configuration. */
const Configuration = () => <Navigate to="/settings/configuration" replace />;

export default Configuration;
